import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./FAQ.css";

const faqData = [
  {
    question: "What instruments does Melodia Music cover?",
    answer: (
      <>
        Piano, Bass, Guitar, Drums, and Trumpet — plus Audio-Engineering
        training and Tracks/Software coaching for <em>Logic Pro</em>,{" "}
        <em>Ableton Live</em>, and <em>MainStage</em>.
      </>
    ),
  },
  {
    question: "Are lessons online or in person?",
    answer: (
      <>
        Both. In-person (San Jose) by appointment, or live via Zoom with a clear
        multi-camera/direct-audio setup so you can see hands/fretboard and hear
        clean audio.
      </>
    ),
  },
  {
    question: "Do you teach beginners?",
    answer: (
      <>
        Absolutely. All levels welcome — we build a personalized plan with clear
        steps and practical goals.
      </>
    ),
  },
  {
    question: "How long is each lesson?",
    answer: (
      <ul>
        <li>
          Piano, Bass, Guitar: <strong>60 minutes</strong>
        </li>
        <li>
          Drums, Trumpet: <strong>45 minutes</strong>
        </li>
        <li>
          Tracks &amp; Software (Logic, Ableton, MainStage):{" "}
          <strong>60 minutes</strong>
        </li>
        <li>
          Audio-Engineering training (live sound/DAW):{" "}
          <strong>2-hour minimum</strong>
        </li>
      </ul>
    ),
  },
  {
    question: "What do lessons include?",
    answer: (
      <ul>
        <li>A customized Google Doc with notes, goals, and assignments</li>
        <li>Curated resources and exercises tailored to your level</li>
        <li>
          Optional 2–3 minute reference videos during the week (by request)
        </li>
        <li>
          All required sheet music and chord charts are{" "}
          <strong>provided by Melodia Music</strong> — no extra material costs
        </li>
      </ul>
    ),
  },
  {
    question: "What ages do you teach?",
    answer: <>All ages — from young beginners to adult learners.</>,
  },
  {
    question: "Do you give group lessons?",
    answer: (
      <>
        Yes. Group lessons are available for{" "}
        <strong>piano, bass, guitar, trumpet</strong> and for{" "}
        <strong>tracks &amp; software</strong>. See rates on the{" "}
        <Link to="/pricing">Pricing</Link> page.
      </>
    ),
  },
  {
    question: "How much do lessons cost?",
    answer: (
      <>
        We keep rates and package options on a dedicated page so it’s always up
        to date. Visit <Link to="/pricing">Pricing</Link> for details.
      </>
    ),
  },
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const toggleIndex = (index) =>
    setActiveIndex(index === activeIndex ? null : index);

  return (
    <section id="faq" className="faq-section">
      <h2>Frequently Asked Questions</h2>
      <div className="faq-container">
        {faqData.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
            onClick={() => toggleIndex(index)}
          >
            <div className="faq-question">{faq.question}</div>
            <div className="faq-answer">{faq.answer}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
